angular.module('ufcw')

.constant('EnvConfig', {
  "URL_API"			: "https://api-agenda.reservasweb.uy/",
  "URL_IMAGES"  : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/demo/",
  "URL_FILES"   : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/demo/",
  "COMPANY_ID"  : "1",
  "SIGNIN_ENABLED":true,
  "RESERVATION_ENABLED":true,
  "footer_app_name":"ReservasWeb",
  "footer_email":"hi@squal.us",
  "footer_facebook":"https://www.facebook.com/reservasweb",
  "footer_twitter":"https://twitter.com/reservasweb",
  "footer_instagram":"https://www.instagram.com/reservasweb",
  "footer_youtube":false,
  "show_aviso_covid":true,
  "show_reglas":false,
  "signup_nrosocio":false,
  "signup_dob":false,
  "projectname":"reservasweb",
  "show_payment_expiration": false,
  "show_carnet_expiration": true
});
